import { __assign, __extends } from "tslib";
import { on } from "../../../utils/Dom";
import BaseObserver from "../BaseObserver";
import EventTypes from "../EventTypes";
import { isExitPosition } from "../Utils";
export var ExitEventDetectionTypes;
(function (ExitEventDetectionTypes) {
    ExitEventDetectionTypes["MouseExitPosition"] = "mouse-exit-position";
    ExitEventDetectionTypes["MouseDocumentLeave"] = "mouse-document-leave";
})(ExitEventDetectionTypes || (ExitEventDetectionTypes = {}));
/**
 * Exit
 * Knows how to detect when client stops watching a page
 */
var Exit = /** @class */ (function (_super) {
    __extends(Exit, _super);
    function Exit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * isDetectionPostponed
         * stop detecting temp.
         */
        _this.isDetectionPostponed = false;
        /**
         * delayAfterDetected
         * Once the exit position has been detected, wait x amount of ms before exit
         * can be detected again to prevent spamming.
         */
        _this.delayAfterDetected = 3500;
        _this.detectByPosition = function (position) {
            if (isExitPosition(position) && _this.isStarted && !_this.isDetectionPostponed) {
                _this.setExitDetected(position, ExitEventDetectionTypes.MouseExitPosition);
            }
        };
        _this.handleMouseMove = function (event) {
            if (!_this.isDetectionPostponed) {
                _this.detectByPosition({ x: event.clientX, y: event.clientY });
            }
        };
        _this.handleMouseLeave = function (event) {
            if (!_this.isDetectionPostponed) {
                var target = event.relatedTarget || event.toElement;
                if (!target || target.nodeName === "HTML") {
                    _this.setExitDetected({ x: 0, y: 0 }, ExitEventDetectionTypes.MouseDocumentLeave);
                }
            }
        };
        return _this;
    }
    Exit.prototype.start = function () {
        _super.prototype.start.call(this);
        this.listenToMouseMoveDetacher = on(document, "mousemove", this.handleMouseMove);
        this.listenToMouseLeaveDetacher = on(document, "mouseleave", this.handleMouseLeave);
    };
    Exit.prototype.stop = function () {
        _super.prototype.stop.call(this);
        this.listenToMouseMoveDetacher();
        this.listenToMouseLeaveDetacher();
        clearTimeout(this.detectProcess);
    };
    Exit.prototype.setExitDetected = function (position, detectionType) {
        var _this = this;
        var event = __assign(__assign({}, position), { type: EventTypes.Exit, detectionType: detectionType });
        this.isDetectionPostponed = true;
        setTimeout(function () {
            _this.isDetectionPostponed = false;
        }, this.delayAfterDetected);
        this.callback(event);
    };
    return Exit;
}(BaseObserver));
export default Exit;
//# sourceMappingURL=Exit.js.map